import React from 'react'
import LineChartComponent from './charts/LineChart'

export default function Gray({
  report = [],
  indicator = '',
  stageOne = '',
  xAngle = 0,
  xDataKey = 'indicator',
  yDataKey = 'average',
}) {
  return (
    <div>
      {/* {JSON.stringify(report)} */}
      <LineChartComponent
        data={report}
        indicator={indicator}
        xAngle={xAngle}
        stageOne={stageOne}
        xDataKey={xDataKey}
        yDataKey={yDataKey}
      />
    </div>
  )
}
